import { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import LoadingContent from '../../component/loading/LoadingContent'
import styled from "styled-components";

import Actions from "../../redux/actions";

const Section = styled.section`
    height: 100%;

    & > .container{ 
        height: 100%;

        & > .row{ margin-top: 10px; }
    }
`;

export default function Index(props) {

    const [content, setContent] = useState(false)
    const dispatch = useDispatch()

    useEffect(() => {
        dispatch(Actions.master.setPath("/waiting-for-approve"))
        setContent(true)
    }, [dispatch])
    
    return (
        <Section className={"section-dashboard" + (props.className ? props.className : "")}>
          <div className="container">
            {!content ? <LoadingContent/>
            :
            <>
                <h1>Waiting-for-approve</h1>
            </>
            }
          </div>
      </Section>
    )
}
